// extracted by mini-css-extract-plugin
module.exports = {"container":"input-suggestion_container__eVRKK","suggestionContainer":"input-suggestion_suggestionContainer__9upK_","suggestionItem":"input-suggestion_suggestionItem__1lL7w"};